<template>
  <div name="lesson">
    <div>
      <div class="flex space-x-6 w-full">
        <div
          class="sm:w-2/12 hidden sm:block bg-white h-screen"
          v-if="newAddition === false"
        >
          <div class="bg-gray-200 p-3">Options</div>
          <ul class="flex flex-col">
            <li
              v-for="row in navList"
              :key="row.model"
              class="border-b cursor-pointer"
            >
              <a
                @click="showViewFromKey(row.model)"
                class="flex flex-row justify-between px-4 items-center h-12"
                v-bind:class="
                  row.model === selectedKey
                    ? 'text-action-blue transform translate-x-2'
                    : 'text-gray-500 hover:text-gray-800 transform hover:translate-x-2 transition-transform ease-in duration-200'
                "
              >
                <div>
                  <i
                    class="inline-flex items-center justify-center text-xs fas pr-2"
                    v-bind:class="
                      isComplete(row.model) ? 'fa-check-circle' : 'fa-circle'
                    "
                  ></i>
                  <span class="text-sm font-medium">{{ fieldTitle(course.subject_id, row, lesson.layout) }}</span>
                </div>
                <i class="fas fa-chevron-right opacity-50 text-xs"></i>
              </a>
            </li>
          </ul>
        </div>
        <div class="w-full pr-4 flex space-x-4">
          <form
            v-on:submit.prevent="submitLesson"
            class="w-95p mx-auto bg-white rounded-lg p-6"
          >
            <div v-if="isInformationView" class="px-4">
              <div class="flex flex-wrap -mx-3 mb-8">
                <div class="w-11/12">
                  <label class="form-label" for="grid-title">
                    Lesson Name
                  </label>
                  <input
                    v-model="name"
                    class="mb-2 focus:border-red-200 focus:bg-white focus:outline-none"
                    id="grid-title"
                    type="text"
                    placeholder="Enter lesson name"
                  />
                  <p class="text-red-300 text-xs italic">
                    Please fill out this field.
                  </p>
                </div>
              </div>


      <div class="grid grid-cols-1 space-y-1 flex flex-wrap -mx-3 mb-8">
        <div class="w-11/12">
          <div class="font-semibold flex justify-between w-ful pb-2 w-11/12">
            <label class="form-label" for="grid-title">  
            Keywords (Tags)
            </label>
                    <div class="flex"> 
                      <div class="bg-blue-500 tag-example mr-2 w-10"
                      @click="addTags('sen')">#sen</div>

                      <div class="bg-orange-500 tag-example"
                      @click="addTags('ofsted')">#ofsted</div>
                    </div>
                    
                  </div>
                  <input
                v-model="tags"
                class="p-1"
                type="text"
                placeholder="Enter tags..."
              />
              </div>
      </div>

              <div class="flex flex-wrap -mx-3 mb-8">
                <div class="w-11/12">
                  <label class="form-label" for="grid-title">
                    Lesson Layout
                  </label>
                  <div>
                    <button
                      v-for="item in layouts"
                      :key="item.key"
                      type="button"
                      v-on:click="setLessonLayout(item)"
                      v-bind:class="
                        isLayout(item)
                          ? 'bg-gray-500 text-white'
                          : 'bg-gray-200 text-gray-600'
                      "
                      class="mr-3 mb-2 rounded p-2 px-5 cursor-pointer font-bold hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue"
                    >
                      <i
                        class="far pr-1"
                        v-bind:class="
                          isLayout(item) ? 'fa-check-circle' : 'fa-circle'
                        "
                      ></i>
                      {{ item.name }}
                    </button>
                  </div>
                </div>
              </div>

              <div class="flex flex-wrap -mx-3 mb-8">
                <div class="w-full">
                  <label class="form-label" for="grid-title">
                    Visible On System
                  </label>
                  <button
                    type="button"
                    class="mr-3 mb-2 rounded p-2 px-6 cursor-pointer hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue font-bold icon fa-check"
                    v-bind:class="[
                      true === isActive
                        ? 'bg-gray-500 text-white'
                        : 'bg-gray-200 text-gray-600',
                    ]"
                    @click="isActive = true"
                  >
                    Active
                  </button>

                  <button
                    type="button"
                    class="mr-3 mb-2 rounded p-2 px-6 cursor-pointer hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue font-bold icon fa-times"
                    v-bind:class="[
                      false === isActive
                        ? 'bg-gray-500 text-white'
                        : 'bg-gray-200 text-gray-600',
                    ]"
                    @click="isActive = false"
                  >
                    Off
                  </button>
                  <p class="text-red-300 text-xs mt-1 italic">
                    Please fill out this field.
                  </p>
                </div>
              </div>
            </div>

            <div v-else-if="isLogisticsView">
              <div class="small pb-4">
                <label class="form-label" for="grid-equipment">
                  Lesson Equipment
                </label>
                <vue-editor
                  :editorToolbar="customToolbar"
                  v-model="lesson.equipment"
                  class="mb-2 focus:border-red-200 focus:bg-white focus:outline-none"
                  id="grid-equipment"
                  placeholder="Enter any equipment needed for the lesson"
                ></vue-editor>
              </div>

              <div class="small">
                <label class="form-label" for="grid-space">
                  Lesson Location / Space
                </label>
                <vue-editor
                  :editorToolbar="customToolbar"
                  class="mb-2 focus:border-red-200 focus:bg-white focus:outline-none"
                  v-model="lesson.location"
                  id="grid-space"
                  placeholder="Enter lesson location / space"
                ></vue-editor>
              </div>
            </div>

            <div v-else-if="isOutlineView">
              <label class="form-label" for="grid-space"> Outline </label>
              <vue-editor
                v-model="outline"
                :editorToolbar="customToolbar"
                id="grid-outline"
                class="mb-2 focus:border-red-200 focus:bg-white focus:outline-none"
                placeholder="Type or copy and paste your outlines here"
              ></vue-editor>
              <p class="text-red-300 text-xs italic pt-1">
                Please fill out this field.
              </p>
            </div>

            <div v-else-if="isMainView">
              <div v-show="lessonType != 'empty'">
                <div
                  class=""
                  v-bind:style="
                    isDocument ? 'min-height:500px' : 'min-height:300px'
                  "
                >
                  <label class="form-label" for="grid-space">
                    Main Content
                  </label>
                  <vue-editor
                    v-model="maincontent"
                    :editorToolbar="customToolbar"
                    v-show="
                      lessonType === 'textonly' || lessonType === 'fieldscon'
                    "
                    class="mb-2 focus:border-red-200 focus:bg-white focus:outline-none"
                    placeholder="Type or copy and paste your content here"
                  ></vue-editor>

                  <upload
                    :currentFile="fileUrl"
                    @file="setFile"
                    v-show="isDocument"
                    v-if="isDocument"
                  ></upload>
                </div>
              </div>
            </div>

            <div v-else>
              <div class="col-12 col-12-xsmall">
                <label class="form-label" for="grid-space">
                  {{ selectedKey }}
                </label>
                <vue-editor
                  v-model="fieldValues[selectedKey]"
                  :editorToolbar="customToolbar"
                ></vue-editor>
              </div>
            </div>

            <div class="mt-8 block right">
              <div class="text-center" v-if="warningVisible">
                <h2 class="text-lg">File Empty - Are you sure</h2>
                <p class="text-red">
                  You have selected file upload but not added a file
                </p>
                <div class="flex mx-auto w-6/12 p-2 space-x-4 pb-4">
                  <button
                    @click="processLesson()"
                    class="publish-button hover:opacity-75 w-full cursor-pointer bg-green-400"
                  >
                    Continue to Publish Changes
                  </button>
                  <button
                    @click="cancel()"
                    class="publish-button hover:opacity-75 w-full cursor-pointer bg-red-400"
                  >
                    Cancel
                  </button>
                </div>
              </div>

              <button
                v-else
                type="submit"
                class="publish-button hover:opacity-75 w-full"
                v-bind:class="
                  !isDisabled
                    ? 'cursor-pointer'
                    : 'bg-gray-200 cursor-not-allowed'
                "
                :disabled="isDisabled"
              >
                Publish Changes
              </button>

              <savenotice :title="'Lesson'" ref="saveNotice"></savenotice>
            </div>
          </form>

          

          <div v-if="showResources" class="w-4/12 space-y-6 flex-column">
            <div class="bg-white rounded-lg p-4">
              <CurriculumResources
                v-if="lesson != undefined"
                :course="course"
                :lesson="lesson"
                :displayKey="selectedKey"
              >
              </CurriculumResources>
            </div>

            <div class="bg-white rounded-lg p-4" v-if="hasVideoAdmin">
              <CurriculumVideos
                v-if="lesson != undefined"
                :course="course"
                :lesson="lesson"
                :displayKey="selectedKey"
              >
              </CurriculumVideos>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { VueEditor } from "vue2-editor";
const upload = () => import("@/components/customunit/UnitUpload.vue");
const savenotice = () => import("@/components/SaveNotice.vue");
const CurriculumResources = () =>
  import("@/components/curriculum/CurriculumResources.vue");
const CurriculumVideos = () =>
  import("@/components/curriculum/CurriculumVideos.vue");

import { Fields } from "@/models/settings";
import { layoutTypeList } from "@/assets/js/utils";
import { SchoolService } from "@/services/school.service";
import { lessonContentMixin } from "@/mixins/lessonContentMixin.js";

export default {
  name: "lesson",
  mixins: [lessonContentMixin],
  props: {
    course: { type: Object, required: true },
    lesson: { type: Object, required: true },
    newAddition: { type: Boolean, required: false, default: false },
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
      settings: "settings",
    }),
    isDisabled() {
      if (this.name.length > 0) {
        return false;
      } else {
        return true;
      }
    },
    isFields() {
      return ["fields", "fieldscon"].includes(this.lessonType);
    },
    isDocument() {
      return ["fields", "file"].includes(this.lessonType);
    },
    navList() {
      let list = [...new Set(this.navRows)];
      if (this.layoutType != "empty") {
        list.push({ name: "Main Content", model: "main-session" });
      }

      // optional fields
      if (this.isFields) {
        let fields = this.navigationFieldList(this.course.subject_id).map(function (field) {
          return field
        });
        list = list.concat(fields);
      }

      return list;
    },
    isInformationView() {
      return this.selectedKey === "information";
    },
    isLogisticsView() {
      return this.selectedKey === "logistics";
    },
    isMainView() {
      return this.selectedKey === "main-session";
    },
    isOutlineView() {
      return this.selectedKey === "outline";
    },
    showResources() {
      return (
        this.newAddition == false &&
        !this.isInformationView &&
        !this.isLogisticsView
      );
    },
    hasVideoAdmin() {
      return this.currentUser.isContentAdmin || this.currentUser.isOrganisation;
    },
  },
  data() {
    return {
      name: this.lesson.name === undefined ? "" : this.lesson.name,
      tags: "",
      isActive: this.lesson.active === 0 ? false : true,
      lessonType: "file",
      fileUrl:
        this.lesson.document_url === undefined ? "" : this.lesson.document_url,
      outline: this.removeEncodesFromString(this.lesson.outline),
      maincontent: this.removeEncodesFromString(this.lesson.maincontent),
      canSave: false,
      layouts: layoutTypeList(),
      fieldConfig: {},
      fieldValues: {},
      selectedKey: "information",
      navRows: [
        { name: "Lesson Details", model: "information" },
        { name: "Logistics", model: "logistics" },
        { name: "Outline", model: "outline" },
      ], // columns

      opened: [],
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link"],
        ["code-block"],
        ["clean"],
      ],
      warningVisible: false,
    };
  },
  created() {
    if (this.lesson != undefined) {
      if (this.lesson.layout === "") {
        this.lessonType = "fieldscon";
      } else if (this.lesson.layout != undefined) {
        this.lessonType = this.lesson.layout;
      }
    }
    this.setExtraFields();
  },
  methods: {
    setExtraFields() {
      this.fieldValues["performance"] = this.removeEncodesFromString(
        this.lesson.performance
      );
      this.fieldValues["warm-up"] = this.removeEncodesFromString(
        this.lesson.warmup
      );
      this.fieldValues["collaboration"] = this.removeEncodesFromString(
        this.lesson.collaboration
      );
      this.fieldValues["introduction"] = this.removeEncodesFromString(
        this.lesson.introduction
      );
      this.fieldValues["health"] = this.removeEncodesFromString(
        this.lesson.health
      );
      this.fieldValues["game-session"] = this.removeEncodesFromString(
        this.lesson.gamecontent
      );
      this.fieldValues["competition"] = this.removeEncodesFromString(
        this.lesson.competition
      );
      this.fieldValues["conclusion"] = this.removeEncodesFromString(
        this.lesson.conclusion
      );
      this.fieldValues["activities"] = this.removeEncodesFromString(
        this.lesson.activities
      );

      if (this.lesson.tags != null || this.lesson.tags != undefined) {
        this.tags = this.lesson.tags
      }
    },
    setLessonLayout(layout) {
      this.lessonType = layout.key;
    },
    setActive(active) {
      this.isActive = active;
    },
    isLayout(layout) {
      return this.lessonType == layout.key;
    },
    setTitle(item) {
      return item.value == undefined ? item.name : item.value;
    },
    cancel() {
      this.$emit("append", false);
    },
    setFile(value) {
      this.fileUrl = value;
    },
    completion(reload) {
      this.$emit("append", reload);
      this.$refs.saveNotice.saved();

      //   this.$refs.criteriaSaveNotice.failed();
    },
    alertDisplay() {
      this.warningVisible = true;
    },
    submitLesson() {
      this.warningVisible = false;
      if (
        !this.newAddition &&
        this.fileUrl == "" &&
        this.lessonType === "file"
      ) {
        this.alertDisplay();
      } else {
        this.processLesson();
      }
    },
    processLesson() {
      // values
      this.lesson.name = this.name;
      this.lesson.active = this.isActive === true ? 1 : 0;
      this.lesson.layout = this.lessonType;
      this.lesson.tags = this.tags

      // main fields
      this.lesson.equipment = this.lesson.equipment;
      this.lesson.location = this.lesson.location;
      this.lesson.maincontent = this.parseContent(this.maincontent);
      this.lesson.outline = this.parseContent(this.outline);

      // file
      this.lesson.document_url = this.fileUrl;

      // extra fields
      if (this.isFields) {
        let performance = this.fieldValues["performance"];
        let warmup = this.fieldValues["warm-up"];
        let collaboration = this.fieldValues["collaboration"];
        let introduction = this.fieldValues["introduction"];
        let health = this.fieldValues["health"];
        let gamecontent = this.fieldValues["game-session"];
        let competition = this.fieldValues["competition"];
        let conclusion = this.fieldValues["conclusion"];
        let activities = this.fieldValues["activities"];

        this.lesson.warmup =
          warmup == undefined ? null : this.parseContent(warmup);
        this.lesson.performance =
          performance == undefined ? null : this.parseContent(performance);
        this.lesson.collaboration =
          collaboration == undefined ? null : this.parseContent(collaboration);
        this.lesson.introduction =
          introduction == undefined ? null : this.parseContent(introduction);
        this.lesson.health =
          health == undefined ? null : this.parseContent(health);
        this.lesson.gamecontent =
          gamecontent == undefined ? null : this.parseContent(gamecontent);
        this.lesson.competition =
          competition == undefined ? null : this.parseContent(competition);
        this.lesson.conclusion =
          conclusion == undefined ? null : this.parseContent(conclusion);
        this.lesson.activities =
          activities == undefined ? null : this.parseContent(activities);
      }

      // add new or update
      if (this.lesson.id === undefined) {
        this.lesson.inserted_at = this.lesson.updated_at;

        SchoolService.create("lessons", this.lesson)
          .then((response) => this.completion(true))
          .catch((err) => {
            console.log("Lesson add error " + err);
          });
      } else {
        var lessonPatch = {
          id: this.lesson.id,
          name: this.lesson.name,
          order: this.lesson.order,
          active: this.lesson.active,
          course_id: this.lesson.course_id,
          equipment: this.lesson.equipment,
          document_url: this.lesson.document_url,
          layout: this.lesson.layout,
          styles: this.lesson.styles,
          location: this.lesson.location,
        };

        var updateMask = [];
        switch (this.selectedKey) {
          case "outline":
            updateMask.push("outline");
            lessonPatch.outline = this.lesson.outline;
            break;
          case "introduction":
            updateMask.push("introduction");
            lessonPatch.introduction = this.lesson.introduction;
            break;
          case "main-session":
            updateMask.push("maincontent");
            lessonPatch.maincontent = this.lesson.maincontent;
            break;
          case "warm-up":
            updateMask.push("warmup");
            lessonPatch.warmup = this.lesson.warmup;
            break;
          case "game-session":
            updateMask.push("gamecontent");
            lessonPatch.gamecontent = this.lesson.gamecontent;
            break;
          case "conclusion":
            updateMask.push("conclusion");
            lessonPatch.conclusion = this.lesson.conclusion;
            break;
          case "activities":
            updateMask.push("activities");
            lessonPatch.activities = this.lesson.activities;
            break;
          case "competition":
            updateMask.push("competition");
            lessonPatch.competition = this.lesson.competition;
            break;
          case "performance":
            updateMask.push("performance");
            lessonPatch.performance = this.lesson.performance;
            break;
          case "health":
            updateMask.push("health");
            lessonPatch.health = this.lesson.health;
            break;
        }
        //   collaboration:this.lesson.collaboration,

        let payload = {
          lesson:  lessonPatch,
          updateMask: updateMask,
        };

       // console.log(JSON.stringify(payload));

        SchoolService.patch("lessons", this.lesson.id, payload)
          .then((response) => this.completion(false))
          .catch((err) => {
            console.log("Lesson update error " + err);
          });
      }
    },
    toggleCategory(val) {
      if (this.opened.includes(val)) {
        this.opened = this.opened.filter((item) => item !== val);
      } else {
        this.opened.push(val);
      }
    },
    parseContent(content) {
      if (content === undefined || content === null) {
        return content;
      }

      var parsed = content;
      parsed = parsed.replace(/style\=/g, "xstyle=");
      parsed = parsed.replace(
        /xstyle\="color\: rgb\(230\, 0\, 0\)\;"/g,
        "class='red'"
      );
      parsed = parsed.replace(
        /xstyle\="color\: rgb\(0\, 102\, 204\)\;"/g,
        "class='blue'"
      );
      parsed = parsed.replace(
        /xstyle\="color\: rgb\(0\, 138\, 0\)\;"/g,
        "class='green'"
      );

      return parsed;
    },
    removeEncodesFromString(content) {
      if (content === null) {
        return content;
      }
      var parsed = content.trim();

      parsed = parsed.replace(/<p><\/p>/g, "");
      parsed = parsed.replace(/(\n)/g, "<br/>");
      parsed = parsed.replace(/<p><br><\/p>/g, "");
      parsed = parsed.replace(/<\/h1><br\/><ul>/g, "</h1><ul>");
      parsed = parsed.replace(/<ul><br\/>/g, "<ul>");
      // parsed = parsed.replace(/<\/ul><br\/><h1>/g, '</ul><h1>');
      parsed = parsed.replace("<ul><br/><li>", "<ul><li>");
      parsed = parsed.replace(/<\/li><br\/>/g, "</li>");
      parsed = parsed.replace(/\s{2,}/g, "");
      parsed = parsed.replace(/\t/g, "");
      parsed = parsed.replace(/(\r\n|\n|\r)/g, "");

      return parsed;
    },
    showViewFromKey(key) {
      this.selectedKey = key;
      this.$refs.saveNotice.clean();
    },
    addTags(value) {
      let seperator = this.tags.length > 0 ? " #" : "#"
      this.tags = this.tags + seperator + value
    },
    isComplete(key) {
      switch (key) {
        case "information":
          return this.lesson.name != null && this.lesson.name.length > 1;
          break;
        case "logistics":
          return (
            this.lesson.location != null &&
            this.lesson.location.length > 1 &&
            this.lesson.equipment != null &&
            this.lesson.equipment.length > 1
          );
          break;
        case "main-session":
          return (
            this.lesson.maincontent != null &&
            this.lesson.maincontent.length > 1
          );
          break;
        case "outline":
          return this.lesson.outline != null && this.lesson.outline.length > 1;
          break;
        case "introduction":
          return (
            this.lesson.introduction != null &&
            this.lesson.introduction.length > 1
          );
          break;
        case "warm-up":
          return this.lesson.warmup != null && this.lesson.warmup.length > 1;
          break;
        case "game-session":
          return (
            this.lesson.gamecontent != null &&
            this.lesson.gamecontent.length > 1
          );
          break;
        case "competition":
          return (
            this.lesson.competition != null &&
            this.lesson.competition.length > 1
          );
          break;
        case "conclusion":
          return (
            this.lesson.conclusion != null && this.lesson.conclusion.length > 1
          );
          break;
        case "performance":
          return (
            this.lesson.performance != null &&
            this.lesson.performance.length > 1
          );
          break;
        case "collaboration":
          return (
            this.lesson.collaboration != null &&
            this.lesson.collaboration.length > 1
          );
          break;
        case "health":
          return this.lesson.health != null && this.lesson.health.length > 1;
          break;
        case "activities":
          return (
            this.lesson.activities != null && this.lesson.activities.length > 1
          );
          break;

        default:
          return false;
          break;
      }
    },
  },
  components: {
    VueEditor,
    upload,
    savenotice,
    CurriculumResources,
    CurriculumVideos,
  },
};
</script>

<style>
.section-head {
  @apply text-xl m-5 ml-0 font-bold text-orange-500;
}

.boxer {
  @apply mb-8 bg-gray-100 py-3 rounded border border-gray-300;
}

.boxer-header {
  @apply block uppercase tracking-wide text-blue-700 text-sm font-bold mb-3;
}

.lesson-text {
  width: 91% !important;
  color: #2e2f31 !important;
}

.lesson-detail div {
  margin-bottom: 22px;
}

.row::after {
  content: "";
  clear: both;
  display: none;
}

.extra textarea {
  margin-bottom: 12px;
}

#main .inner section.upload {
  padding-bottom: 1em;
}

.ql-snow .ql-editor h1 {
  font-size: 1.1em !important;
  margin-bottom: 8px !important;
}

.ql-snow .ql-editor h2 {
  font-size: 0.9em !important;
  margin-bottom: 8px !important;
}

.ql-snow .ql-editor h3 {
  font-size: 0.8em !important;
  margin-bottom: 8px !important;
}

.ql-editor {
  min-height: 350px !important;
}

.small .ql-editor {
  min-height: 130px !important;
}

.ql-editor p {
  @apply text-sm !important mb-3  !important;
  font-size: 0.83rem !important;
}

.ql-editor ul {
  @apply text-sm !important mb-3  !important;
}
</style>
